<template>
  <div class="row">
      <div class="col-md-12 card">
        <div class="card-header">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <h5 class="card-title">{{ $t('field_scans')}}</h5>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 text-center">
                  <a class="btn btn-xs text-white" style="background-color:black" @click.prevent="goToSoilAdvise()">
                    {{ $t('view_soil_advice') }}
                  </a>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center">
                  <a class="btn btn-xs text-white" style="background-color:red" @click.prevent="goBack()">
                    <i class="fa fa-backward"></i>
                    {{ $t('back') }}
                  </a>
                </div>
            </div>
        </div>

        <div class="card-body" v-loading="loading" :element-loading-text="$t('loading_data')+'...'" >
          <div class="row">
            <div class="col-md-6">
              <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
              </el-select>
            </div>
            <!-- <div class="col-sm-6">
              <div class="pull-right">
                <fg-input
                  class="input-sm"
                  placeholder="Search"
                  v-model="searchQuery"
                  addon-right-icon="nc-icon nc-zoom-split"
                ></fg-input>
              </div>
            </div> -->
          </div>
          <hr>
          <div class="row" v-for="(soil, index) in paginated" :key="index">

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="card" style="border: 2px solid #FEC04A">
                    <div class="card-header text-center">
                    <h6 class="card-title">{{ soil.Title }}</h6>
                  </div>
                  <div class="card-body">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                              <th>{{ $t('name') }}</th>
                              <th>{{ $t('density') }}</th>
                              <th>{{ $t('density_text') }}</th>
                              <th>{{ $t('MinThreshold') }}</th>
                              <th>{{ $t('MaxThreshold') }}</th>
                              <th>{{ $t('unit_name')}}</th>
                              <th>{{ $t('display_value')}}</th>
                              <th>{{ $t('value') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(data, key) in soil.Elements" :key="key">
                            <td>{{ data.Name }}</td>
                            <td>{{ data.Density }}</td>
                            <td>{{ data.Density_Text }}</td>
                            <td>{{ data.MinThreshold }}</td>
                            <td>{{ data.MaxThreshold }}</td>
                            <td>{{ data.UnitName }}</td>
                            <td>{{ data.DisplayValue }}</td>
                            <td>{{ data.Value }}</td>
                          </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
              </div>

          </div>

        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col-sm-6 pagination-primary">
                  <p class="category">{{ $t('showing') }} {{pagination.from}} {{ $t('to') }} {{pagination.to}} {{ $t('of') }} {{pagination.total}} {{ $t('entries') }}</p>
                </div>
                <div class="col-sm-6">
                  <p-pagination
                    class="pull-right"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="pagination.total"></p-pagination>
                </div>
             </div>
          </div>
      </div>
  </div>
</template>
<script>
import Resource from "@/util/Api/resource.js";
const ordersResource =  new Resource('soilcare/allOrders');
const reportResource =  new Resource('soilcare/orderReports');
import PPagination from "src/components/UIComponents/Pagination.vue";
export default {
  components:{
    PPagination,
  },
  data() {
    return {
       soilLink:"",
       uniqueIDs:"",
       loading:false,
       SoilFertility:[],
       SuitableCrop:[],
       searchQuery:'',
       pagination:{
          perPage: 5,
          perPageOptions: [10, 20, 30, 60, 500, 1000],
          currentPage:1,
          nextPage:'',
          prevPage:'',
          total:'',
          from:'',
          to:'',
          page:'',
       },
    }
  },

  methods: {

    // go back
    goBack(){
       this.$router.push({ name: "ShowList" });
    },

    // go back
    goToSoilAdvise(){
       this.$router.push({ name: "SoilAdvise", params: { data: this.SuitableCrop }});
    },

    // order by month
    orderByLetter(a, b) {
      const bandA = a.Name;
      const bandB = b.Name;
      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },

    // get orders
    async getOrdersData(){
       this.loading = true;
       await ordersResource.list({})
       .then((response) =>{
          //console.log('res', JSON.parse(response.data));
          let orders = JSON.parse(response.data);

          orders.forEach(element => {
             if(element.FieldUniqueId === this.soilLink){
                // console.log('UniqueID', element.UniqueId);
                this.uniqueIDs += "," + element.UniqueId;
             }
          });

          if(this.uniqueIDs){
             this.getOrdersReport();
          }

       }).catch((error) => {
          console.log(`Getting data failed ${error}`);
       });

      //  console.log(this.uniqueIDs.slice(1));
    },

    // get orders report
    async getOrdersReport(){
        await reportResource.get(this.uniqueIDs.slice(1))
        .then((response) => {

            let reports = response.data;

            //console.log('soil advice', reports);

            reports.forEach((element) => {

               //console.log('Element', JSON.parse(element));

               let elements = JSON.parse(element);

              elements.Pages.forEach((value) =>{

                if(value.SoilFertilityStatus !== null){
                  this.SoilFertility.push(value.SoilFertilityStatus);
                }

                if(value.SuitableCropTypes !== null){
                  this.SuitableCrop.push(value.SuitableCropTypes);
                }

              });

            });

            //console.log('Data', this.SoilFertilityStatus.sort(this.orderByLetter));
            //console.log('Suitable Crop', this.SuitableCrop);

        }).catch((error) => {
            console.log(`Getting data failed ${error}`);
        }).finally(() =>{
            this.loading = false;
        });
    },

    paginate(array, length, pageNumber){
        this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
        this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
        this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
        this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
        this.pagination.page = Math.ceil(array.length / length);
        this.pagination.total = array.length;
        return array.slice((pageNumber - 1) * length, pageNumber * length);
    },

  },


  mounted() {
    this.soilLink = localStorage.getItem("soilLink");
    this.getOrdersData();
  },

  computed: {
    filterData() {
        let result = this.SoilFertility;
        // if (this.searchQuery) {
        //     result = result.filter((row) => {
        //         return Object.keys(row.Elements).some((key) => {
        //             return (String(row.Elements[key]).toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1);
        //         })
        //     })
        // }
        return result;
    },

    paginated(){
        return this.paginate(this.filterData, this.pagination.perPage, this.pagination.currentPage);
    },

  },

}
</script>
